export const MENU_DASHBOARD = "dashboard";
export const MENU_MESSAGES = "messages";
export const MENU_SUBSCRIPTIONS = "subscriptions";
export const MENU_SETTINGS = "settings";
export const MENU_PROFILE = "profile";

export const MENU_MEMBERS = "members";
export const MENU_INTEGRATIONS = "integrations";
